import { render, staticRenderFns } from "./actual.vue?vue&type=template&id=b3a12c76&"
import script from "./actual.vue?vue&type=script&lang=js&"
export * from "./actual.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports